import type { ISerialize } from '@/objects/ISerialize';

export class SeedingListSelectLine implements ISerialize {
    public text: string;

    public value: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { text?: string | null; value?: number }) {
        this.text = values.text ?? '';

        this.value = values.value ?? 0;
    }

    public serialize(): string {
        return '{' + `"text": ${JSON.stringify(this.text)}` + ',' + `"value": ${JSON.stringify(this.value)}` + '}';
    }

    /**
     * Creates an instance of SeedingListSelectLine from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { text?: string | null; value?: number }): SeedingListSelectLine {
        return new SeedingListSelectLine(values);
    }

    public static _FromServerJson(json: any): SeedingListSelectLine {
        return new SeedingListSelectLine({ text: json.text ?? '', value: json.value });
    }

    /**
     * Creates an instance of SeedingListSelectLine from another instance of SeedingListSelectLine.
     * @param other The SeedingListSelectLine you want to clone
     * @returns A cloned SeedingListSelectLine
     */
    public static FromOther(other: SeedingListSelectLine): SeedingListSelectLine {
        return SeedingListSelectLine._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SeedingListSelectLine.FromOther(this);
    }

    static NAME_OF_CLASS = 'SeedingListSelectLine';
}
